export enum AUTH_METHODS {
  APPLE = 'apple',
  GOOGLE = 'google',
  EMAIL = 'email_password',
}

export enum UNAUTHORIZED_PATHS {
  RESET_PASSWORD = 'reset-password',
}
